<template>
  <div class="user-manage">
    <div class="top">
      <div class="left">用户列表</div>
      <el-button type="primary" @click="setUser(false)">新增用户</el-button>
    </div>
    <div class="table-box">
      <el-table :data="tableData" style="width: 100%">
        <!-- <el-table-column prop="index" label="编号"> </el-table-column> -->
        <el-table-column label="序号" type="index" align="center" width="50x">
        </el-table-column>
        <el-table-column prop="name" label="姓名"> </el-table-column>
        <el-table-column prop="username" label="账号"> </el-table-column>
        <!-- <el-table-column prop="mobile" label="手机号"> </el-table-column> -->
        <el-table-column prop="roleNames" label="角色"> </el-table-column>
        <el-table-column prop="mobile" label="手机号"> </el-table-column>
        <el-table-column prop="accsms" label="接收报警短信">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.accsms == 1">是</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="createTime" label="创建时间"> </el-table-column>
        <el-table-column prop="edit" label="操作" width="120">
          <template slot-scope="scope">
            <div class="btn-out-box">
              <div class="btn-box color1" title="编辑" @click="setUser(scope.row)">
                <i class="iconfont icon-bianji1"></i>
              </div>
              <div class="btn-box color2" title="删除" @click="deleteUser(scope.row)">
                <i class="iconfont icon-close"></i>
              </div>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <!-- <el-pagination
        class="m-t-20"
        background
        :current-page.sync="currentPage"
        layout="prev, pager, next"
        :total="total"
        @current-change="paginationHandle"
      >
      </el-pagination> -->
      <div class="pagination-info">
        <div class="left">
          第 {{ currentPage }} 页（共{{ Math.ceil(total / size) }}页），显示{{
            (currentPage - 1) * size + 1
          }}至{{
            currentPage * size >= total ? total : currentPage * size
          }}项结果，共{{ total }}项
        </div>
        <div class="right">
          <el-pagination @size-change="handleSizeChange" @current-change="paginationHandle"
            :page-sizes="[5, 10, 15, 20]" :page-size="size" layout="total, sizes, prev, pager, next, jumper"
            :total="total">
          </el-pagination>
        </div>
      </div>
    </div>
    <el-dialog title="新增/编辑用户" :visible.sync="dialogFormVisible">
      <el-form :label-position="'right'" label-width="120px" :model="form" :rules="rules" ref="ruleForm">
        <el-form-item label="姓名：" prop="name">
          <el-input v-model.trim="form.name"></el-input>
        </el-form-item>
        <el-form-item label="账号：" prop="username">
          <el-input v-model="form.username" value=" " onkeyup="value=value.replace(/[^\w\.\/]/ig,'')"></el-input>
        </el-form-item>
        <el-form-item label="密码：" prop="password">
          <el-input v-model.trim="form.password" show-password></el-input>
        </el-form-item>
        <el-form-item label="角色配置：" prop="roleId">
          <!-- <el-radio v-model="form.roleId" label="3">企业主管</el-radio>
          <el-radio v-model="form.roleId" label="2">项目管理员</el-radio>
          <el-radio v-model="form.roleId" label="1">值班员</el-radio> -->
          <el-radio v-model="form.roleId" label="2">企业主管</el-radio>
          <!-- <el-radio v-model="form.roleId" label="3">实施技术人员</el-radio> -->
          <el-radio v-model="form.roleId" label="1">值班人员</el-radio>
          <!-- <template> -->
          <el-radio v-model="form.roleId" v-for="(item) in roleList" :key="item.id"
            :label="item.id">{{ item.roleName }}</el-radio>
          <!-- </template> -->



        </el-form-item>
        <el-form-item label="手机号：" prop="mobile">
          <el-input v-model.trim="form.mobile" type="number"></el-input>
        </el-form-item>
        <el-form-item label="接收报警短信：">
          <el-switch v-model="form.accsms" active-color="#13ce66" :active-value="1" :inactive-value="0">
          </el-switch>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="addUserHandle">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import tool from "../../utils/tool";
import {
  Message
} from 'element-ui';
export default {
  data() {
    const validatePhone = (rule, value, callback) => {
      if (!value) {
        callback();
      } else if (!/^1[3-9]\d{9}$/.test(value)) {
        callback(new Error('请输入正确的手机号格式'));
      } else {
        callback();
      }
    };
    return {
      id: "",
      isAdd: true,
      tableData: [],
      dialogFormVisible: false,
      currentPage: 1,
      size: 10,
      total: 0,
      form: {
        index: "",
        username: "",
        name: "",
        mobile: "",
        createTime: "",
        roleNames: "",
        roleId: "",
        accsms: 0
      },
      roleList: [],
      rules: {
        username: [
          { required: true, message: '请输入登录账号', trigger: 'blur' },
          { min: 3, max: 10, message: '长度在 3 到 10 个字符', trigger: 'blur' }
        ],
        name: [
          { required: true, message: '请输入姓名', trigger: 'blur' },
          { min: 2, max: 6, message: '长度在 2 到 6 个字符', trigger: 'blur' }
        ],
        password: [
          { min: 6, max: 12, message: '长度在 6 到 12 个字符', trigger: 'blur' }
        ],
        roleId: [
          { required: true, message: '请选择一个角色', trigger: 'blur' },
        ],
        mobile: [
          { validator: validatePhone, trigger: 'blur' }
        ]
      }
    };
  },
  created() {
    this.id = this.$route.params.id;
    this.searchUsersByProject();
  },
  methods: {
    paginationHandle(index) {
      this.currentPage = index;
      this.searchUsersByProject();
    },
    handleSizeChange(e) {
      this.currentPage = 1;
      this.size = e;
      this.searchUsersByProject();
    },
    searchUsersByProject() {
      this.$http
        .post("bma-user-service/project/searchProjectUsers", {
          projectId: this.id,
          currentPage: this.currentPage,
          size: this.size,
        })
        .then((res) => {
          console.log("res: ", res);
          let arr = [];
          this.total = res.data.total;
          setTimeout(() => {
            res.data.records.forEach((item, index) => {
              item.index = index + 1;
              item.roleCheckedList.forEach((i) => {
                if (i.checked) {
                  item.roleId = i.id + "";
                }
              });
              // if (item.status) {
              arr.push(item);
              // }
            });
            console.log(arr);
            this.tableData = arr;
          }, 500);
        });
    },
    setUser(e) {
      // false 新增
      if (e) {
        // 编辑
         this.$set(this.rules, 'password', [
            { min: 6, max: 12, message: '长度在 6 到 12 个字符', trigger: 'blur' }
          ]);
        this.isAdd = false;
         this.form = {
          password: ""
        };
        this.form = e;
        this.dialogFormVisible = true;
      } else {
        // 新增
         this.$set(this.rules, 'password', [
            { required: true, message: '请输入密码', trigger: 'blur' },
            { min: 6, max: 12, message: '长度在 6 到 12 个字符', trigger: 'blur' }
          ]);
        this.isAdd = true;
        this.form = {
          name: "",
          username: "",
          password: "",
          roleId: "",
        };
        this.dialogFormVisible = true;
      }

      this.$http
        .post("bma-user-service/role/searchRoleCustom", {
        })
        .then((res) => {
          this.roleList = res.data
        });

      this.$refs['ruleForm'].resetFields();
    },
    addUserHandle() {
      var me = this
      this.$refs['ruleForm'].validate((valid) => {
        if (valid) {
          me.dialogFormVisible = false;
          if (me.isAdd) {
            me.addNoManagerUsers();
          } else {
            me.updateUserInfo();
            me.updateProjectUserRole();
          }
        } else {
          return false;
        }
      });
    },
    updateProjectUserRole() {
      this.$http
        .post("bma-user-service/user/updateProjectUserRole", {
          roleId: Number(this.form.roleId),
          userId: this.form.id,
        })
        .then((res) => {
          if (res.code == 200) {
            Message.success("修改成功");
            this.searchUsersByProject();
          }
        });
    },
    addNoManagerUsers() {
      this.form.projectId = this.id;
      this.form.dataType = "";
      this.form.username = tool.filterChinese(this.form.username);
      this.$http
        .post("bma-user-service/user/addNoManagerUsers", this.form)
        .then((res) => {
          console.log("xinzeng: ", res);
          if (res.code == 200) {
            Message.success("新增成功");
            this.searchUsersByProject();
          }
        });
    },
    updateUserInfo() {
      this.form.dataType = 1;
      this.$http
        .post("bma-user-service/user/updateUserInfo", this.form)
        .then((res) => {
          if (res.code == 200) {
            this.currentPage = 1;
            this.searchUsersByProject();
          }
        });
    },
    deleteUser(e) {
      this.$confirm("确认删除此用户？")
        .then((_) => {
          this.deleteUserHandle(e);
        })
        .catch((_) => { });
    },
    deleteUserHandle(e) {
      this.$http
        .post(
          "bma-user-service/user/deleteUser",
          {
            userId: e.id,
          }
          // {
          //   headers: {
          //     userId: e.id,
          //   },
          // }
        )
        .then((res) => {
          if (res.code == 200) {
            Message.success("删除成功");
            this.currentPage = 1;
            this.searchUsersByProject();
          }
        });
    },
    setShebei(e) {
      if (!e.isOpen) return;
      this.drawer = true;
    },
  },
};
</script>
<style lang="less" scoped>
.user-manage {
  background: #f8f8f9;
  padding: 20px;
  border-radius: 7px;

  .top {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 10px;
    margin-bottom: 28px;

    .left {
      font-size: 18px;
      font-weight: 600;
    }
  }

  .table-box {
    text-align: center;

    .el-table {
      background: rgba(0, 0, 0, 0);

      /deep/th,
      tr {
        background: rgba(0, 0, 0, 0);
      }

      /deep/th {
        >.cell {
          color: #152139;
          font-size: 14px;
          font-weight: 600;
          text-align: center;
        }
      }

      /deep/tr {
        td {
          font-size: 14px;
          color: #152139;
          text-align: center;
        }
      }

      .btn-out-box {
        display: flex;
        justify-content: space-around;
      }

      .btn-box {
        width: 24px;
        height: 24px;
        background: rgba(165, 165, 165, 0.1);
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;

        .iconfont {
          font-size: 12px;
          color: rgba(195, 195, 195, 1);
        }

        &.color1:hover {
          background: rgba(20, 96, 224, 0.1);

          .iconfont {
            color: rgba(20, 96, 224, 1);
          }
        }

        &.color2:hover {
          background: rgba(255, 41, 41, 0.1);

          .iconfont {
            color: rgba(255, 41, 41, 1);
          }
        }

        &.color3.active {
          background: rgba(253, 151, 101, 0.1);

          .iconfont {
            color: rgba(253, 151, 101, 1);
          }
        }
      }
    }
  }

  .pagination-info {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 10px;

    .left {
      font-size: 12px;
      color: rgba(137, 146, 159, 1);
    }
  }

  /deep/.el-dialog {
    width: 35%;

    .el-dialog__title {
      font-weight: 600;
    }

    .el-input {
      // width: 323px;
    }
  }
}
</style>